import DeleteIcon from '@mui/icons-material/Delete';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Button, IconButton } from '@mui/material';
import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import ImagesWithZoom from '../Images/ImagesWithZoom';

interface ImageUploadProps {
  idInput: string;

  buttonText: string;
  setSelectedImage: React.Dispatch<React.SetStateAction<File | null>> | React.Dispatch<React.SetStateAction<File[] | null>>;
  selectedImage: File | null | any[];
  indexPhoto?: number;

  imageUrl?: string;

  enablePreview?: boolean;
  customPrevieContentNode?: React.ReactNode;

  accept?: string;

  onClickTrash?: () => void;

  onRemoveImage?: (imageUrl?: any, selectedImage?: any) => void;
  onChangeImage?: (imageUrl?: any, selectedImage?: any) => void;

  disabledInput?: boolean;

  showCustomPreviewEdit?: boolean;
  customPreviewEditNode?: React.ReactNode;
  endIcon?: React.ReactNode;
  canDelete?: boolean;
}

const tiposPermitidos = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

const ImageUploadComponente: React.FC<ImageUploadProps> = ({
  idInput,
  buttonText,
  setSelectedImage,
  selectedImage,
  indexPhoto,

  enablePreview = true,
  customPrevieContentNode,

  imageUrl = '',

  accept = 'image/*',

  onClickTrash,
  onRemoveImage,
  onChangeImage,

  disabledInput = false,

  showCustomPreviewEdit = false,
  customPreviewEditNode,
  endIcon,
  canDelete = true
}) => {

  const [imagenUrlAux, setImagenUrlAux] = useState<string>(imageUrl);
  const fileInputRef = useRef<HTMLInputElement>(null);


  // Manejo de cambios en el input
  // const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   const files = event.target.files;
  //   if (!files || files.length === 0) return;

  //   const file = files[0];
  //   if (!tiposPermitidos.includes(file.type)) {
  //     toast.info('El archivo tiene que ser una imagen.');
  //     return;
  //   }

  //   if (indexPhoto !== undefined && indexPhoto !== null) {
  //     const newSelectedImages: File[] = Array.isArray(selectedImage) ? [...selectedImage] : [];
  //     newSelectedImages[indexPhoto] = file;
  //     setSelectedImage(newSelectedImages as any);
  //     onChangeImage && onChangeImage(imageUrl, newSelectedImages); 
  //   } else {
  //     setSelectedImage(file as any);
  //     onChangeImage && onChangeImage(imageUrl, file); 
  //   }
  // };
  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    if (!tiposPermitidos.includes(file.type)) {
      toast.info('El archivo tiene que ser una imagen.');
      return;
    }

    const buffer = await file.arrayBuffer();
    const safeFile = new File([buffer], file.name, { type: file.type });

    if (indexPhoto !== undefined && indexPhoto !== null) {
      const newSelectedImages: File[] = Array.isArray(selectedImage) ? [...selectedImage] : [];
      newSelectedImages[indexPhoto] = safeFile;
      setSelectedImage(newSelectedImages as any);
      onChangeImage && onChangeImage(imageUrl, newSelectedImages);
    } else {
      setSelectedImage(safeFile as any);
      onChangeImage && onChangeImage(imageUrl, safeFile);
    }
  };

  
  const fileToShow = useMemo(() => {
    return indexPhoto !== undefined && indexPhoto !== null
      ? (selectedImage as File[])?.[indexPhoto]
      : selectedImage as File | undefined;
  }, [selectedImage, indexPhoto]);


  useEffect(() => {
    if (fileToShow instanceof File) {
      const url = URL.createObjectURL(fileToShow);
      setImagenUrlAux(url);
      return () => URL.revokeObjectURL(url); // limpia memoria
    } else {
      setImagenUrlAux(imageUrl);
    }
  }, [fileToShow, imageUrl]);


  return (
    <div>
      <input
        type="file"
        accept={accept}
        ref={fileInputRef}
        onChange={e => {
          if (disabledInput) return;
          handleFileChange(e);
          // onChangeImage && onChangeImage(imageUrl, selectedImage);
        }}
        style={{ display: 'none' }}
        id={'image-upload-input-' + idInput}
        disabled={disabledInput}
      />
      <label htmlFor={'image-upload-input-' + idInput}>
        <Button
          variant="contained"
          component="span"
          fullWidth
          size="small"
          startIcon={<FileUploadIcon />}
          endIcon={endIcon && endIcon}
          style={{
            padding: '5.5px 14px',
            backgroundColor: 'white',
            border: '1px solid #b8bdc1',
            color: '#6C737F',
            borderRadius: 10,
            textTransform: 'none',
            fontFamily: 'Helvetica',
            fontWeight: '400',
            fontSize: '1rem',
            justifyContent: 'center',
            minHeight: '45px',
          }}
        >
          {buttonText}
        </Button>
      </label>

      {(
      (indexPhoto==undefined && selectedImage != null) 
      || ( indexPhoto!=undefined && indexPhoto!=null && (selectedImage as File[])?.[indexPhoto] != null) || imagenUrlAux) 
      && enablePreview && (
        <>
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            {canDelete ? (
              <IconButton
                aria-label="Eliminar"
                onClick={() => {
                  if (indexPhoto !== undefined && indexPhoto !== null) {
                    if (Array.isArray(selectedImage)) {
                      const newImages = [...selectedImage];
                      newImages[indexPhoto] = null;
                      setSelectedImage(newImages as any);
                    }
                  } else {
                    setSelectedImage(null);
                  }
              
                  setImagenUrlAux('');
                  if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                  }
              
                  onClickTrash && onClickTrash();
                  onRemoveImage && onRemoveImage(imagenUrlAux, selectedImage);
                }}
              >
                <DeleteIcon />
              </IconButton>

            ) : null}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '5px' }}>
            

            <ImagesWithZoom
              src={imagenUrlAux}
              alt={buttonText}
            />
          </div>
        </>
      )}

      {!enablePreview && selectedImage && customPrevieContentNode && (
        <>{customPrevieContentNode}</>
      )}

      {showCustomPreviewEdit && customPreviewEditNode && <>{customPreviewEditNode}</>}
    </div>
  );
};

export default ImageUploadComponente;
